import { __rest } from "tslib";
import React from 'react';
import { FloatingDropdown } from 'wix-ui-tpa';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { HorizontalDivider } from '../dividers';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { COMMENTS_HEADER, HEADER_TITLE, SORTING_SELECTOR, } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { CommentsHeaderRatings } from './comments-header-ratings';
import { classes, st } from './comments-header.st.css';
export const CommentsHeader = React.memo((_a) => {
    var _b;
    var { commentCount, hideTitle } = _a, props = __rest(_a, ["commentCount", "hideTitle"]);
    const t = useTranslate();
    const { blackAndWhiteModals, a11yOptions, headerTitleText } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    return (React.createElement(React.Fragment, null,
        isMobile && React.createElement(HorizontalDivider, { type: "header" }),
        React.createElement("div", { className: st(classes.root, { isMobile }), "data-hook": COMMENTS_HEADER },
            React.createElement("div", { className: classes.innerContainer },
                hideTitle && !props.hideRatings && isMobile ? null : (React.createElement("div", { className: classes.left },
                    !hideTitle &&
                        React.createElement((_b = a11yOptions === null || a11yOptions === void 0 ? void 0 : a11yOptions.headerRank) !== null && _b !== void 0 ? _b : 'span', { className: classes.title, 'data-hook': HEADER_TITLE }, headerTitleText
                            ? headerTitleText(commentCount !== null && commentCount !== void 0 ? commentCount : 0)
                            : t('header.all-comments', {
                                count: commentCount !== null && commentCount !== void 0 ? commentCount : 0,
                            })),
                    !props.hideRatings && !isMobile && (React.createElement("div", { className: classes.ratingsContainer },
                        React.createElement(CommentsHeaderRatings, Object.assign({}, props.ratings)))))),
                React.createElement("div", { className: classes.right }, !props.hideSorting && (React.createElement(FloatingDropdown, { className: st(classes.dropdown, { blackAndWhite: !!blackAndWhiteModals }), value: props.selectedSort, "data-hook": SORTING_SELECTOR, onChange: (option) => { var _a; return (_a = props.onSortChange) === null || _a === void 0 ? void 0 : _a.call(props, option.id); }, options: props.sortOptions, label: isMobile ? '' : t('header.sort-by') })))),
            !props.hideRatings && isMobile && (React.createElement("div", { className: classes.ratingsContainer },
                React.createElement(CommentsHeaderRatings, Object.assign({}, props.ratings)))))));
});
CommentsHeader.displayName = 'CommentsHeader';
// As we need the header visibility inside rootBox this can not become a part of component - it
// has to be resolved higher up the component tree
export const resolveHeaderVisibility = ({ hideHeader, hideSorting, hideTitle, hideRatings, }) => hideHeader || (hideSorting && hideTitle && hideRatings)
    ? { type: 'HIDDEN' }
    : {
        type: 'VISIBLE',
        visibilityProps: {
            hideSorting: !!hideSorting,
            hideTitle: !!hideTitle,
            hideRatings: !!hideRatings,
        },
    };
//# sourceMappingURL=comments-header.js.map